// Routing constants
export const accountURLParam = 'accountId' as const;
export const accountPrefix = `/acc/:${accountURLParam}` as const;

export const productFeedPath = 'feeds';
export const productFeedInfoPath = 'product-feed-info';
export const backButtonUrlParamsKey = 'backButtonUrlParams';
